import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { API, LoadError, Loading, Welcome, dayLabel, errText, timeLabel, useHeaders, useLoad, usePortal, useSubmit } from '../../components/clientportal/kit';

const DRAFT = 'gcp_message_draft';

export default function ClientMessagesPage() {
  const headers = useHeaders();
  const { toast } = usePortal();
  const [msgs, reload, err] = useLoad('/api/portal/messages');
  const [text, setText] = useState(() => sessionStorage.getItem(DRAFT) || '');
  const [busy, run] = useSubmit();
  const body = useRef(null);
  useEffect(() => { sessionStorage.setItem(DRAFT, text); }, [text]);
  useEffect(() => { if (body.current) body.current.scrollTop = body.current.scrollHeight; }, [msgs]);
  useEffect(() => { const t = setInterval(reload, 30000); return () => clearInterval(t); }, [reload]);
  const send = (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    run(async (rid) => {
      try { await axios.post(`${API}/api/portal/messages`, { body: text.trim(), client_request_id: rid }, { headers }); setText(''); sessionStorage.removeItem(DRAFT); reload(); }
      catch (er) { toast(errText(er)); }
    });
  };
  return (
    <div data-testid="client-messages">
      <Welcome title={<>Your team. <em>One conversation.</em></>} desc="Keep the details of your clean together." />
      <section className="panel chat" style={{ padding: 0 }}>
        <div className="chat-head"><span className="avatar light">GG</span><div><h2>Gleam Guru team</h2><p>Scheduling, property questions & service follow-up</p></div></div>
        <div className="chat-body" ref={body} data-testid="chat-body">
          {err && !msgs ? <LoadError text={err} onRetry={reload} /> : !msgs ? <Loading />
            : msgs.length ? msgs.map((m) => (
              <div key={m.id} className={`bubble${m.mine ? ' mine' : ''}`} data-testid={`message-${m.id}`}>
                <small>{m.mine ? 'You' : m.author} · {dayLabel(m.created_at)} {timeLabel(m.created_at)}</small><p>{m.body}</p>
              </div>))
              : <p className="empty" data-testid="messages-empty">No messages yet. Ask about scheduling, your property or anything about your clean.</p>}
        </div>
        <form className="compose" onSubmit={send} data-testid="message-form">
          <label htmlFor="message">Message your team</label>
          <textarea id="message" required maxLength={2000} value={text} onChange={(e) => setText(e.target.value)} placeholder="What would you like your team to know?" data-testid="message-input" />
          <div className="split"><small className="muted">Your team replies here during business hours (Pacific time).</small>
            <button className="primary" type="submit" disabled={busy || !text.trim()} data-testid="message-send">{busy ? 'Sending…' : 'Send message ↗'}</button></div>
        </form>
      </section>
    </div>
  );
}
